<template>
  <div>{{ model }}</div>
</template>

<script>
export default {
  name: "integer",
  data() {
    return {
      model: null
    };
  },
  props: ["input", "form"],
  created() {},
  watch: {
    form() {
      if (this.form) {
        this.model = null;
      }
    },
    model() {
      this.$parent.$emit("changed", {
        name: this.input.name,
        value: this.model
      });
    }
  }
};
</script>

<style></style>
